import {
  Component,
  EventEmitter,
  HostBinding,
  Input,
  Output,
} from '@angular/core';
import {
  MzicSkeletonComponent,
  MzicSvgComponent,
} from '@mzic/mzic-components';

export type CollectionTargetLoadingMean = 'UPLOAD' | 'CONNECTION';

@Component({
  selector: 'lib-target-route-loading-step',
  imports: [MzicSkeletonComponent, MzicSvgComponent],
  templateUrl: './target-route-loading-step.component.html',
  styleUrl: './target-route-loading-step.component.scss',
})
export class TargetRouteLoadingStepComponent {
  @Input({ required: true }) mean!: CollectionTargetLoadingMean;
  @Input() errorMessage: string | null = null;

  @Output() retry = new EventEmitter<void>();
  @Output() back = new EventEmitter<void>();

  readonly placeholders = [1, 2, 3, 4];

  @HostBinding('attr.data-target-mean')
  get targetMean(): CollectionTargetLoadingMean {
    return this.mean;
  }

  @HostBinding('attr.data-load-state')
  get loadState(): 'loading' | 'error' {
    return this.errorMessage ? 'error' : 'loading';
  }
}
